import LoanInstallmentItem from './loan-installment-item';

export default LoanInstallmentItem;
